import script from "./MultiPositionPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiPositionPanel.vue?vue&type=script&lang=ts&setup=true"

import "./MultiPositionPanel.vue?vue&type=style&index=0&id=31558b7a&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31558b7a"]])

export default __exports__